import $ from "jquery";

const ATTR_ROOT = "data-wizard-root";
const ATTR_PAGE = "data-wizard-page";
const ATTR_ACT = "data-wizard";
const ATTR_PRESET = "data-wizard-preset";
const DATA_KEY = "wizard-page-attr";

function tok2arr(tok) {
  return tok.split(/\s+|\b/);
}

function getPageAttrPart(val) {
  let invert = false;

  let [trigger, action] = val.split(/\s*:\s*/);

  trigger = tok2arr(trigger);
  action = tok2arr(action);

  if(trigger[0] === "!") {
    invert = true;
    trigger.shift();
  }

  return { trigger, action, invert };
}

function getPageAttrImpl(el) {
  const str = $(el).attr(ATTR_PAGE);
  return str ? str.split(/\s*,\s*/).map(getPageAttrPart) : [];
}

function setPageAttr(el, pageAttr) {
  $(el).data(DATA_KEY, pageAttr);
}

function getPageAttr(el) {
  let pageAttr = $(el).data(DATA_KEY);
  if(!pageAttr) {
    pageAttr = getPageAttrImpl(el);
    setPageAttr(el, pageAttr);
  }
  return pageAttr;
}

function init(sel) {
  const $root = $(sel);
  const $togglable = $root
    .find(`[${ATTR_PAGE}], [${ATTR_PRESET}]`)
    .filter(function(i, el) { return $(el).closest("[data-wizard-root]").get(0) === $root.get(0); });

  let curr = 0;
  let valid = 0;
  let last = 0;

  const visibleInputs = (() => {
    const cache = {};
    return () => {
      if(cache.hasOwnProperty(curr)) return cache[curr];
      return cache[curr] = $root.find(".box-content :input:visible");
    }
  })();

  // enter for next page
  $root.find(`:input`).on("keypress", $evt => {
    if($evt.key === "Enter" && curr < last) {
      goto(curr+1);
      $evt.preventDefault();
      return false;
    }
  });

  function translatePage(page) {
    switch (page) {
      case "first": return 0;
      case "last": return last;
      case "page": return curr;
      case "valid": return valid;
      case "prev": return curr-1;
      case "next": return curr+1;
    }

    return parseInt(page);
  }

  function evalOp(a, op, b) {
    a = translatePage(a);
    b = translatePage(b);

    switch(op) {
      case "=": return a === b;
      case "<": return a < b;
      case ">": return a > b;
    }

    console.warn(`Wizard: invalid operator "${op}"`);
    return false;
  }

  function evalTrigger(trigger) {
    return evalOp(trigger[0], trigger[1], trigger[2]);
  }

  function performAction(el, action, pred) {
    switch(action[0]) {
      case "class":
        $(el).toggleClass(action[1], pred);
        break;
      case "prop":
        $(el).prop(action[1], pred);
        break;
      default:
        console.warn(`Wizard: invalid action "${action[0]}"`);
    }
  }

  function toggleStuff() {
    $togglable.each((i, el) => {
      const vals = getPageAttr(el);
      for (let j = 0; j < vals.length; j++) {
        const {trigger, action, invert} = vals[j];
        const pred = evalTrigger(trigger) !== invert;
        // console.log(invert && "!" || " ", trigger, action, pred, last);
        performAction(el, action, pred);
      }
    });
  }

  function validate() {
    const $inputs = visibleInputs();
    for (let i = 0; i < $inputs.length; i++) {
      if(!$inputs.get(i).checkValidity()) {
        return false;
      }
    }

    return true;
  }

  function goto(next) {
    if (next === curr || next < 0 || next > last) return;

    const shouldValidate = next > curr;
    let isValid = validate();
    let focusFirstInvalid = false;

    if (isValid) {
      valid = Math.max(valid, next);
    } else {
      valid = curr;
    }

    if (!shouldValidate || isValid) {
      curr = next;
      $root.find(".needs-validation").removeClass("was-validated");
    } else {
      focusFirstInvalid = true;
      visibleInputs().closest(".needs-validation").addClass("was-validated");
    }

    toggleStuff();

    let $focusable = visibleInputs();
    if(focusFirstInvalid) {
      const $invalid = $focusable.filter(":invalid");
      if($invalid.length) $focusable = $invalid;
    }
    $focusable.first().focus();

    $root.trigger("wizard.change.void", curr);
    $root.trigger(`wizard.change:${curr}.void`);
  }

  $root.on("click", `[${ATTR_ACT}]`, $evt => {
    const act = tok2arr($($evt.target).closest(`[${ATTR_ACT}]`).attr(ATTR_ACT));
    switch(act[0]) {
      case "goto":
        goto(translatePage(act[1]));
        break;

      default:
        console.warn(`Wizard: unknown action "${act[0]}"`);
    }
  });

  // presets
  function applyPreset(el) {
    const $el = $(el);
    const preset = tok2arr($el.attr(ATTR_PRESET));
    let presetAttr = [];

    switch(preset[0]) {
      case "show":
        presetAttr = [{
          trigger: ["page", "=", preset[1]],
          action: ["class", "d-none"],
          invert: true
        }];
        break;

      case "hide":
        presetAttr = [{
          trigger: ["page", "=", preset[1]],
          action: ["class", "d-none"],
          invert: false
        }];
        break;

      case "tab":
        presetAttr = [{
          trigger: ["valid", "<", preset[1]],
          action: ["prop", "disabled"],
          invert: false
        }, {
          trigger: ["valid", "<", preset[1]],
          action: ["class", "disabled"],
          invert: false
        }, {
          trigger: ["page", "=", preset[1]],
          action: ["class", "active"],
          invert: false
        }];

        $el.on("click", () => goto(translatePage(preset[1])));
        break;

      default:
        console.warn(`Wizard: unknown preset "${preset[0]}"`);
        return;
    }

    setPageAttr(el, presetAttr.concat(getPageAttrImpl(el)));
  }

  $root.find(`[${ATTR_PRESET}]`).each((i, el) => { applyPreset(el); });

  // najit posledni
  $togglable.each((i, el) => {
    const vals = getPageAttr(el);
    for (let j = 0; j < vals.length; j++) {
      const trigger = vals[j].trigger;
      if(!isNaN(trigger[0])) last = Math.max(last, parseInt(trigger[0]));
      if(!isNaN(trigger[2])) last = Math.max(last, parseInt(trigger[2]));
    }
  });

  $root.find(`[${ATTR_ACT}]`).each((i, el) => {
    const act = tok2arr($(el).attr(ATTR_ACT));
    if(act[0] === "goto" && !isNaN(act[1])) last = Math.max(last, parseInt(act[1]));
  });

  // focus on modal open
  {
    const $modal = $root.closest(".modal");
    $modal.on("shown.bs.modal", () => {
      visibleInputs().first().focus();
    });
  }

  toggleStuff();
}

function initAll() {
  $(`[${ATTR_ROOT}]`).each((i, el) => { init(el); });
}

// init all on document load
$(initAll);

export const Wizard = {
  init,
  initAll
};